import React, { useState } from 'react';
import '../styles/dropdown.css';
import { Add } from '@mui/icons-material';

interface DropdownProps {
    label: string;
    children: React.ReactNode;
    maxHeight?: string;
    isCodeBlock?: boolean;
    startOpen?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({ label, children, maxHeight = '500px', startOpen = false }) => {
    const [isOpen, setIsOpen] = useState(startOpen);
    const [animationClass, setAnimationClass] = useState("");

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        setAnimationClass("popup-little");
        setTimeout(() => setAnimationClass(""), 300);
    };

    return (
        <div className="dropdown">
            <button onClick={toggleDropdown} className={`dropdown-button ${isOpen ? 'open' : ''} ${animationClass}`}>
                <div className="label-container">
                    {/* {!isCodeBlock && <DescriptionOutlined className="code-icon" />}
                    {isCodeBlock && <Code className="code-icon" />} */}
                    {label}
                </div>
                <Add className={`dropdown-icon ${isOpen ? 'open' : ''}`} />
            </button>
            <div
                className={`dropdown-content ${isOpen ? 'show' : ''}`}
                style={{ maxHeight: isOpen ? maxHeight : '0px' }}
            >
                {children}
            </div>
        </div>
    );
};

export default Dropdown;